import React from 'react'

const SiteActionModal = props => {
  return (
    <div
      style={{
        position: 'fixed',
        top: '85%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <div
        style={{
          width: '350px',
          height: '55px',
          backgroundColor: '#3E3F42',
          borderRadius: '5px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <p style={{ color: 'white', fontSize: '14px' }}>
          {props.siteAction === 'create' && 'New Site Created'}
          {props.siteAction === 'edit' && 'Site Updated'}
          {props.siteAction === 'delete' && 'Site Deleted'}
        </p>
      </div>
    </div>
  )
}

export default SiteActionModal
